const CreditCardIcon = ({ width = 24, height = 24, fill = "#011851" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M3.59998 7.2V9.6H20.4V7.2C20.4 6.53625 19.8637 6 19.2 6H4.79998C4.13623 6 3.59998 6.53625 3.59998 7.2ZM3.59998 10.8V16.8C3.59998 17.4638 4.13623 18 4.79998 18H19.2C19.8637 18 20.4 17.4638 20.4 16.8V10.8H3.59998ZM5.99998 15C5.99998 14.67 6.26998 14.4 6.59998 14.4H7.79998C8.12998 14.4 8.39998 14.67 8.39998 15C8.39998 15.33 8.12998 15.6 7.79998 15.6H6.59998C6.26998 15.6 5.99998 15.33 5.99998 15ZM9.59998 15C9.59998 14.67 9.86998 14.4 10.2 14.4H11.4C11.73 14.4 12 14.67 12 15C12 15.33 11.73 15.6 11.4 15.6H10.2C9.86998 15.6 9.59998 15.33 9.59998 15Z"
      fill={fill}
      fillOpacity="0.5"
    />
    <path
      d="M19.2 6.00005C19.8638 6.00005 20.4 6.5363 20.4 7.20005V9.60005H3.60002V7.20005C3.60002 6.5363 4.13627 6.00005 4.80002 6.00005H19.2ZM20.4 10.8V16.8C20.4 17.4638 19.8638 18 19.2 18H4.80002C4.13627 18 3.60002 17.4638 3.60002 16.8V10.8H20.4ZM4.80002 4.80005C3.47627 4.80005 2.40002 5.8763 2.40002 7.20005V16.8C2.40002 18.1238 3.47627 19.2 4.80002 19.2H19.2C20.5238 19.2 21.6 18.1238 21.6 16.8V7.20005C21.6 5.8763 20.5238 4.80005 19.2 4.80005H4.80002ZM6.00002 15C6.00002 15.33 6.27002 15.6 6.60002 15.6H7.80002C8.13002 15.6 8.40002 15.33 8.40002 15C8.40002 14.67 8.13002 14.4 7.80002 14.4H6.60002C6.27002 14.4 6.00002 14.67 6.00002 15ZM9.60002 15C9.60002 15.33 9.87002 15.6 10.2 15.6H11.4C11.73 15.6 12 15.33 12 15C12 14.67 11.73 14.4 11.4 14.4H10.2C9.87002 14.4 9.60002 14.67 9.60002 15Z"
      fill={fill}
    />
  </svg>
);

export default CreditCardIcon;
